module.exports = __webpack_public_path__ + "img/spinner.a3f29f6b.svg";